var _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedLineGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 59,
    viewBox: "0 0 72 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    strokeLinejoin: "square",
    strokeLinecap: "butt",
    d: "M1 59V41C1 35.4771 5.47714 31 11 31H13L61 31C66.5229 31 71 26.5228 71 21L71 0",
    stroke: "url(#paint_black_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 31,
    r: 2,
    fill: "url(#paint_red_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_black_linear",
    x1: 71,
    y1: 24.5,
    x2: 1,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197898,
    stopColor: "#797D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE2E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_red_linear",
    x1: 10,
    y1: 31,
    x2: 14,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B31217"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLineGroup);
export default __webpack_public_path__ + "static/media/redLineGroup.a83d725a.svg";
export { ForwardRef as ReactComponent };